// extracted by mini-css-extract-plugin
module.exports = {"radio":"styles_radio__Wao3y","radio__input":"styles_radio__input__4qcLS","radio__label":"styles_radio__label__zhjah"};